/**
 * Defines a palette of Tailwind color classes for tags.
 * Each entry includes background, text, and border classes.
 */
const TAG_COLORS = [
    'bg-danger/10 text-danger border-danger/20 dark:bg-danger/20 dark:text-danger dark:border-danger/30',
    'bg-orange-50 text-orange-600 border-orange-100 dark:bg-orange-900/50 dark:text-orange-100 dark:border-orange-800',
    'bg-amber-50 text-amber-600 border-amber-100 dark:bg-amber-900/50 dark:text-amber-100 dark:border-amber-800',
    'bg-yellow-50 text-yellow-600 border-yellow-100 dark:bg-yellow-900/50 dark:text-yellow-100 dark:border-yellow-800',
    'bg-orange-50 text-orange-600 border-orange-100 dark:bg-orange-900/50 dark:text-orange-100 dark:border-orange-800',
    'bg-brand-hover/10 text-brand-hover border-brand-hover/20 dark:bg-brand-primary/20 dark:text-brand-primary dark:border-brand-primary/30',
    'bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-900/50 dark:text-emerald-100 dark:border-emerald-800',
    'bg-teal-50 text-teal-600 border-teal-100 dark:bg-teal-900/50 dark:text-teal-100 dark:border-teal-800',
    'bg-cyan-50 text-cyan-600 border-cyan-100 dark:bg-cyan-900/50 dark:text-cyan-100 dark:border-cyan-800',
    'bg-sky-50 text-sky-600 border-sky-100 dark:bg-sky-900/50 dark:text-sky-100 dark:border-sky-800',
    'bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-900/50 dark:text-blue-100 dark:border-blue-800',
    'bg-indigo-50 text-indigo-600 border-indigo-100 dark:bg-indigo-900/50 dark:text-indigo-100 dark:border-indigo-800',
    'bg-violet-50 text-violet-600 border-violet-100 dark:bg-violet-900/50 dark:text-violet-100 dark:border-violet-800',
    'bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-900/50 dark:text-purple-100 dark:border-purple-800',
    'bg-fuchsia-50 text-fuchsia-600 border-fuchsia-100 dark:bg-fuchsia-900/50 dark:text-fuchsia-100 dark:border-fuchsia-800',
    'bg-pink-50 text-pink-600 border-pink-100 dark:bg-pink-900/50 dark:text-pink-100 dark:border-pink-800',
    'bg-rose-50 text-rose-600 border-rose-100 dark:bg-rose-900/50 dark:text-rose-100 dark:border-rose-800',
];

/**
 * Generates a consistent color class string for a given tag.
 * Uses a simple hash function to ensure the same tag always gets the same color.
 * 
 * @param tag The tag string.
 * @returns A string of Tailwind CSS classes.
 */
export function getTagColorClass(tag: string): string {
    if (!tag) return 'bg-gray-100 text-gray-600 border-gray-200';

    let hash = 0;
    for (let i = 0; i < tag.length; i++) {
        hash = tag.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % TAG_COLORS.length;
    return TAG_COLORS[index];
}
